import { SensorSkuId } from 'app/modules/inventory/bins/core/enum';
import { SensorConnectionStatus } from 'app/modules/inventory/bins/core/enum';
import { SensorType } from 'app/modules/system-settings/devices/core/enum';
import { DeviceSensorFilterParams } from 'app/modules/system-settings/devices/core/type';

export const MAC_ADDRESS_REGEX = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;

export const FIXED_WIDTH = 15;
export const DYNAMIC_FIELDS = 9;
export const DYNAMIC_WIDTH = (100 - FIXED_WIDTH) / DYNAMIC_FIELDS;

export const DISPLAY_SENSOR_TYPE = {
  [SensorSkuId.Weight]: SensorType.SENSOR_WEIGHT,
  [SensorSkuId.Expiry]: SensorType.SENSOR_CV_EXPIRY,
  [SensorSkuId.CV]: SensorType.SENSOR_CV,
  [SensorSkuId.Hanger]: SensorType.SENSOR_HANGER,
} as const;

export const STATUS_OPTIONS = [
  {
    label: 'Operational',
    value: SensorConnectionStatus.online,
  },
  {
    label: 'No heartbeat',
    value: SensorConnectionStatus.offline,
  },
  {
    label: 'Unassigned',
    value: SensorConnectionStatus.notReady,
  },
];

export const DEFAULT_DEVICE_SENSOR_FILTER: DeviceSensorFilterParams = {
  status: [],
  locationIds: [],
  page: 1,
};

export const DEFAULT_DEVICE_SENSOR_TABLE_QUERY = {
  orderBy: 'createdAt',
  orderDirection: 'DESC',
  page: 1,
  limit: 10,
};
